<template>
  <div v-if="isQrAPI" class="edit-merchant-interface-wrapper">
    <v-row style="align-items: flex-start">
      <v-col cols="10" sm="4">
        <p class="section-title">Apakah anda ingin menambahkan interface tambahan yang digunakan pada integrasi API?</p>
      </v-col>
      <v-col cols="2" sm="1"> : </v-col>
      <v-col cols="12" sm="7" class="d-flex align-center">
        <v-radio-group v-model="needInterface" row @change="handleNeedInterfaceChange" class="ma-0">
          <v-radio label="Tidak" :value="false"></v-radio>
          <v-radio label="Ya" :value="true"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-slide-y-reverse-transition>
      <div v-if="needInterface">
        <v-row style="align-items: center">
          <v-col cols="10" sm="4">Interface</v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-select
              :items="interfaceOptions"
              item-text="label"
              item-value="value"
              v-model="selectedInterfaces"
              multiple
              chips
              label="Pilih Interface"
              @change="handleInterfaceChange"
              :error-messages="interfaceErrors"
              :menu-props="{ offsetY: true, nudgeTop: -5 }"
              class="interface-select"
            >
              <template v-slot:item="{ item }">
                <div class="option-item-wrapper">
                  <div class="option-header">{{ item.label }}</div>
                  <div class="option-description">{{ item.description }}</div>
                </div>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </div>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';

export default {
  name: 'EditMerchantInterfaceField',
  mixins: [validationMixin],

  data() {
    const interfaceOptions = [
      {
        label: 'CPTS',
        value: 'cpts',
        description: 'Digunakan untuk transaksi pembayaran menggunakan token CPTS pada integrasi API'
      }
    ];
    
    const validInterfaceValues = this.qrTypeInterfaceValue.filter(val => 
      interfaceOptions.some(opt => opt.value === val)
    );
    
    return {
      internalNeedInterface: this.needInterfaceValue,
      internalQrTypeInterface: validInterfaceValues,
      interfaceOptions
    };
  },

  validations: {
    selectedInterfaces: {
      required() {
        return this.needInterface ? this.selectedInterfaces.length > 0 : true;
      }
    }
  },

  props: {
    qrType: {
      type: String,
      default: ''
    },
    needInterfaceValue: {
      type: Boolean,
      default: false
    },
    qrTypeInterfaceValue: {
      type: Array,
      default: () => []
    }
  },

  watch: {
    needInterfaceValue(newVal) {
      this.internalNeedInterface = newVal;
    },
    qrTypeInterfaceValue(newVal) {
      const validInterfaceValues = newVal.filter(val => 
        this.interfaceOptions.some(opt => opt.value === val)
      );
      this.internalQrTypeInterface = validInterfaceValues;
    }
  },

  computed: {
    isQrAPI() {
      const apiQrValues = ['2', '4', '5', '7'];
      return apiQrValues.includes(this.qrType);
    },

    needInterface: {
      set(val) {
        this.internalNeedInterface = val;
        this.$emit('update:needInterfaceValue', val);
      },
      get() {
        return this.internalNeedInterface;
      }
    },

    selectedInterfaces: {
      set(val) {
        this.internalQrTypeInterface = val;
        this.$emit('update:qrTypeInterfaceValue', val);
      },
      get() {
        return this.internalQrTypeInterface;
      }
    },

    interfaceErrors() {
      const errors = [];
      if (!this.$v.selectedInterfaces.$dirty) return errors;
      if (!this.$v.selectedInterfaces.required) errors.push('Interface is required');
      return errors;
    }
  },

  methods: {
    handleNeedInterfaceChange(val) {
      if (!val) {
        this.$emit('update:qrTypeInterface', []);
        this.$v.selectedInterfaces.$reset();
      } else {
        this.$v.selectedInterfaces.$touch();
      }
    },

    handleInterfaceChange() {
      if (this.$v.selectedInterfaces.$dirty) {
        this.$v.selectedInterfaces.$touch();
      }
    },

    touchValidation() {
      this.$v.selectedInterfaces.$touch();
    },

    resetValidation() {
      this.$v.selectedInterfaces.$reset();
    }
  }
};
</script>

<style scoped>
.edit-merchant-interface-wrapper {
  width: 100%;
}

.section-title {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  text-align: left;
  line-height: 1.5;
}

.interface-select /deep/ .v-input__slot {
  padding: 0 !important;
}

.v-slide-y-reverse-transition-enter-active,
.v-slide-y-reverse-transition-leave-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.option-item-wrapper {
  padding: 12px 16px;
  width: 100%;
  min-height: auto;
}

.option-header {
  font-weight: 500;
  font-size: 13px;
  color: #333;
  margin-bottom: 6px;
}

.option-description {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}
</style>
